<template>
  <el-dialog
    title="借款单据"
    :visible.sync="dialogVisible"
    width="60%"
    class="advertCostDialog"
    @close="dialogCloseHandle"
  >
    <commonTable ref="loanDetailsTable" />
  </el-dialog>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
export default {
  data () {
    return {
      dialogVisible: false
    };
  },
  props: {
    loanDetailsVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable
  },
  watch: {
    loanDetailsVisible (val) {
      if (val) {
        this.loadTable();
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('25%')
          ._title(this.$t('newApp.activityInfo.jkdh'))
          ._data('instanceCode')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('20%')
      //     ._title('申请金额')
      //     ._data('applyAmount')
      // );
      tableRow.push(
        new TableColumns()
          ._width('25%')
          ._title(this.$t('newApp.activityInfo.jkje'))
          ._data('applyAmount')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <span>{row[column.property] ? row[column.property] : 0}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('25%')
          ._title(this.$t('newApp.activityInfo.wcxje'))
          ._data('owedAmount')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <span>{row[column.property] ? row[column.property] : 0}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('25%')
          ._title(this.$t('newApp.activityInfo.lczt'))
          ._data('currentProcessName')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.loanDetailsTable.setColumn(column, {
          page: false
        });
        this.$refs.loanDetailsTable.loadTable({ url: '/config/annual/market_loan/' + this.rowData.activityExpenseDetails[0].expenseBelongId, method: 'get' });
      });
    }
  }
};
</script>

<style scoped>

</style>
